import {generateRandomState, getRefreshToken} from "./utils"
import {api} from "../http/apiClient"
import axios from "axios";

const baseUrlApi = process.env.REACT_APP_API + "/api/v1"
const baseUrl = process.env.REACT_APP_AMEI
const realm = process.env.REACT_APP_REALM
const client_id = process.env.REACT_APP_CLIENT_ID
const redirect_url = `${window.location.protocol}//${window.location.host}/`


export function redirectToKeycloak () {
  const state = generateRandomState()
  const nonce = generateRandomState()
  const urlParams = {
    client_id,
    redirect_uri: redirect_url,
    response_mode: "fragment",
    response_type: "code",
    scope: "openid",
    nonce,
    state,
  }
  const connectionURI = new URL(
    `${baseUrl}/realms/${realm}/protocol/openid-connect/auth`
  )
  for (const key of Object.keys(urlParams)) {
    connectionURI.searchParams.append(key, urlParams[key])
  }

  window.location.href = connectionURI
}

const ApiAuth = () => {
  const registerLogin = async(access_token, device, browser) => {
    try {

      const {data} = await api.post(`/register-login/`, {
        device,
        browser,
      }, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        }
      })
      if (data) {
        localStorage.setItem('token', data?.access)
        localStorage.setItem('refresh_token', data?.refresh)
      } else {
        localStorage.clear()
        window.location.href = '/acesso-negado'
      }

      return data
    } catch (error) {
      return error
    }
  }

  const getCompanies = () => {
    return api.get(`/get-cnpj/`)
  }

  const skipOnboarding = () => {
    return api.get(`/onboarding/`)
  }
  const finishOnboarding = () => {
    return api.post(`/onboarding/`)
  }

  const checkIsCompletedTutorial = () => {
    return api.get(`/steps/`)
  }
  const setIsCompletedTutorial = () => {
    return api.post(`/steps/`, {})
  }

  const login = async (code) => {
    const params = new URLSearchParams({
      client_id,
      redirect_uri: redirect_url,
      grant_type: 'authorization_code',
      code,
    })

    try {
      const res = await axios.post(
        `${baseUrl}/realms/${realm}/protocol/openid-connect/token`,
        params,
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
      )

      const data = res.data || {}

      const { id_token } = data
      localStorage.setItem('id_token', id_token)

      return data
    } catch (e) {
      return e
    }
  }
  const logout = async () => {
    try {
      return await api.post('/logout/')
    } catch (error) {
      return error
    } finally {
      logoutAMEI()
    }
  }
  const logoutAMEI = () => {
    const logoutURI = new URL(
      `${baseUrl}/realms/${realm}/protocol/openid-connect/logout`
    )
    const id_token_hint = localStorage.getItem("id_token")
    const urlParams = {
      client_id,
      post_logout_redirect_uri: redirect_url,
      id_token_hint,
    }
    for (const key of Object.keys(urlParams)) {
      logoutURI.searchParams.append(key, urlParams[key])
    }

    const tutorialsData = localStorage.getItem("tutorials")
    const tutorials = tutorialsData ? JSON.parse(tutorialsData) : {}
    const isGlobalTutorialCompleted = tutorials.isFinished

    const isCompleted = localStorage.getItem("hideGuidedTourDefault") === "true"
    if (!isCompleted && isGlobalTutorialCompleted) {
      setIsCompletedTutorial()
    }

    localStorage.clear()
    window.location.href = logoutURI
  }
  const refreshToken = async (rt) => {
    const token = rt ?? getRefreshToken()
    if (!token || token === 'undefined') {
      throw new Error('NO_REFRESH_TOKEN')
    }

    const res = await axios.post(`${baseUrlApi}/refresh-token/`, {},
      {
        headers: {'Authorization': `Bearer ${token}`}
      }
    )

    const { access, refresh } = res.data ?? {}
    if (!access) {
      throw new Error('INVALID_REFRESH_RESPONSE')
    }

    localStorage.setItem('token', access)
    if (refresh) localStorage.setItem('refresh_token', refresh)

    return res.data
  }

  return {
    login,
    registerLogin,
    getCompanies,
    skipOnboarding,
    finishOnboarding,
    logout,
    refreshToken,
    checkIsCompletedTutorial,
    setIsCompletedTutorial,
  }
}

export default ApiAuth
